// extracted by mini-css-extract-plugin
module.exports = {"sectionwithad":"sRA4h","sliderBlk":"PZvd_","bannerSlider":"_rXMP","withborder":"HJBxC","fakeLink":"SWr_P","nolink":"jzpQQ"};